import React from "react";

const SuspenseFallback: React.FC = () => {
  return null;
};

export default SuspenseFallback;
